module.exports = __webpack_public_path__ + "img/privatelayer_jp.892c9a3.jpg";